import { callFunctionDirect } from "./fbAll";

export const fsfn_getConfigKey = async (key) => {
  const callData = { key }
  const response = await callFunctionDirect('getConfigKey', callData);
  return response
}

export const fsfn_setConfigKey = async (callData) => {
  const response = await callFunctionDirect('setConfigKey', callData);
  console.log('fsfn_setConfigKey response', response)
  return response
}

export const fsfn_getGeocodeAddress = async (address, mainFunctions) => {
  const callData = { address }
  const response = await callFunctionDirect('geocodeAddress', callData, mainFunctions);
  return response
}